import * as h2oApi from '../api/h2o';
import moment from 'moment';

export const logDataApi = ({rsvnNo, progress, ref}) => {
  if(process.env.REACT_APP_ENV === 'production' && process.env.REACT_APP_H2O_LOG_YN === 'Y' ){
    const date = moment().format('YYYYMMDD');
    h2oApi.logData({hotel: 'SA000001', rsvnNo, progress, type: '1', date: date, ref});
  }
};